import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  price: {
    fontFamily: 'Roboto !important',
    color: 'rgba(0, 0, 0, 0.87) !important',
    fontWeight: '400 !important',
    letterSpacing: '0.15px !important',
    fontSize: '16px !important',
    lineHeight: '160% !important',
    textAlign: 'left',
  },
  priceRecurrent: {
    fontFamily: 'Roboto !important',
    fontSize: '16px !important',
    fontWeight: '400 !important',
    letterSpacing: '0.15px !important',
    lineHeight: '160% !important',
    color: 'rgba(0, 0, 0, 0.87) !important',
    textAlign: 'center',
    [theme.breakpoints.down('md')]: {
      fontSize: '16px !important',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '16px !important',
    },
  },
  priceFrecuency: {
    fontSize: '12px !important',
    fontFamily: 'Roboto !important',
    fontWeight: '400 !important',
    marginLeft: '4px !important',
  },
  separatorContainer: {
    display: 'flex !important',
    justifyContent: 'center !important',
  },
  priceContainer: {
    justifyContent: 'center !important',
    alignItems: 'center !important',
    display: 'flex !important',
  },
  separator: {
    fontSize: '16px !important',
    fontFamily: 'Roboto !important',
    fontWeight: '600 !important',
    margin: '0px 5px !important',
  },
  paymentRecurrentContainer: {
    display: 'flex',
    justifyContent: 'start',
    width: '100%',
  },
  flexStartCenter: {
    display: 'flex',
    justifyContent: 'start',
    alignItems: 'center',
  },
}));
